module.exports = __webpack_public_path__ + "static/media/naba-min.af648d61.png";